import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-finishes',
    templateUrl: './icon-finishes.component.html'
})
export class IconFinishesComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
